
function NewsFilters(){
	$('.list-filters a').click(function(){
		var $this = $(this);
		var $type  = $this.data('type');		
		var $partial = $('.partial.list-news');
		$('.list-filters a').removeClass('active');
		$this.addClass('active');
		$partial.data('route',$type);
		$partial.data('page','1');
		load_partial($partial);
		return false;	
	});	 
}



var FeaturedNews = {
	init:function(){
		$('.featured-news .news-carousel').on('init',function(){
			$('.featured-news').removeClass('loading');
		});
		var featured_news_carousel = $('.featured-news .news-carousel').slick({
			autoplay:true,
  			autoplaySpeed:5000, 
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:true,
			arrows:false
		});


		/*
		featured_news_carousel.on('afterChange', function(){
			var index = Number($('.featured-news .news-carousel .slick-slide.slick-current').data('slick-index'))+1;
			if(index < 10){
				index = "0" + index;
			}
			$('.featured-news .controls .counter .current').html(index);
		});
		*/


		$('.featured-news .slick-prev').click(function(){
			featured_news_carousel.slick('slickPrev');
			return false;
		});
		$('.featured-news .slick-next').click(function(){
			featured_news_carousel.slick('slickNext');
			return false;
		});
	}
};

var RelatedNewsCarrousel = {
	init:function(){
		$('.related-news .related-news-carousel .way-point').each(function( ) {
		 	$(this).removeClass('way-point');
		});
		equalizeHeight('.related-news .related-news-carousel .news-caption');
		var latest_news_carousel = $('.related-news .related-news-carousel').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite:true,
			arrows:false,
			centerMode: false,
			centerPadding: 0,
			responsive: [
			    {
			      breakpoint: 1200,
			      settings: {
			        arrows: false,
					centerPadding: '40px',
			        slidesToShow: 3,
					centerMode: true,
			      }
			    },
			    {
			      breakpoint: 767,
			      settings: {
						arrows: false,
						centerPadding: '40px',
						slidesToShow: 2,
					  centerMode: false,
			      }
			    },
				 {
			      breakpoint: 600,
			      settings: {
						arrows: false,
						centerPadding: '30px',
						slidesToShow: 1,
					  centerMode: true,
			      }
			    },
				 {
			      breakpoint: 380,
			      settings: {
						arrows: false,
						centerPadding: '30px',
						slidesToShow: 1,
					  centerMode: true,
			      }
			    }
			]
		});
	}
};

var LatestNewsCarrousel = {
	init:function(){
		var latest_news_carousel = $('.latest-news.with-carousel .news-carousel').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite:true,
			arrows:false,
			centerMode: false,
			centerPadding: 0,
			swipeToSlide : true,
			responsive: [
			    {
			      breakpoint: 1200,
			      settings: {
			        arrows: false,
					centerPadding: '40px',
			        slidesToShow: 3,
					centerMode: true,
			      }
			    },
			    {
			      breakpoint: 767,
			      settings: {
					arrows: false,
					centerPadding: '40px',
					slidesToShow: 2,
					centerMode: false,
			      }
			    },
				 {
			      breakpoint: 600,
			      settings: {
						arrows: false,
						centerPadding: '0',
						slidesToShow: 2,
						centerMode: false,
			      }
			    },
			]
		});


		latest_news_carousel.on('afterChange', function(){
			var index = Number($('.latest-news.with-carousel .news-carousel .slick-slide.slick-current').data('slick-index'))+1;
			if(index < 10){
				index = "0" + index;
			}
			$('.latest-news.with-carousel .widget-pagination .left span').html(index);
		});

		$('.latest-news.with-carousel .widget-pagination .left').click(function(){
			latest_news_carousel.slick('slickPrev');
			return false;
		});
		$('.latest-news.with-carousel .widget-pagination .right').click(function(){
			latest_news_carousel.slick('slickNext');
			return false;
		});
	}
};

$(window).resize(function(){
	equalizeHeight('.related-news .related-news-carousel .news-caption');
});
